@let isMobileVal = shellState.isMobile();
@let isMinimalLayoutVal = shellState.isMinimalLayout();
@let isSettingsViewVal = isSettingsView();
@let isSidebarAvailablVal = isSidebarAvailable();

@let walkthroughIds = componentsWalkthroughId();

@let navTemplate = isSettingsViewVal ? settingsNavSidebarTpl : mainNavSidebarTpl;

<rt-icons-container />

<div class="banner">
  <ng-content select="banner" />
</div>

<div class="topbar" [class.hidden]="isSettingsViewVal">
  <div class="topbar-start" [style.width.px]="TELLENT_APP_SHELL_LAYOUT.sidebarMinimizedWidth">
    @if (isMobileVal || isMinimalLayoutVal) {
      <tlc-app-switcher-next [walkthroughId]="walkthroughIds.appSwitcher" />
    }

    <div class="topbar-start-label" [style.left.px]="topbarStartLabelOffset()">
      <ng-content select="topbar-start-label" />
    </div>
  </div>

  <div class="topbar-center">
    <ng-content select="topbar-center" />
  </div>
  <div class="topbar-end">
    <ng-content select="topbar-end" />
  </div>
</div>

@if (isSidebarAvailablVal) {
  <ng-container [ngTemplateOutlet]="navTemplate" />
}

<div class="main">
  <ng-content select="main" />
</div>

@if (isMobileVal) {
  <div class="bottom-bar">
    <ng-content select="bottom-bar" />
  </div>
}

<ng-template #mainNavSidebarTpl>
  <tlc-main-navigation
    [shouldExpandNavOnHover]="shouldExpandNavOnHover()"
    [navigationWalkthroughId]="walkthroughIds.navigation"
    [appSwitcherWalkthroughId]="walkthroughIds.appSwitcher"
  />
</ng-template>

<ng-template #settingsNavSidebarTpl>
  <tlc-settings-navigation />
</ng-template>

@if (!isMobileVal) {
  <hr-assistant />
}
